<template>
  <div id="success">
    <Wrap :banner="banner">
      <img class="success-icon" src="@/assets/images/success.png" alt="" />
      <div class="box-title">
        <p>{{ title }}</p>
      </div>
      <!-- <p class="info">{{text}}</p> -->
    </Wrap>
    <Button type="border" @click="back">{{ $t("message.strid21") }}</Button>
    <div class="blank"></div>
  </div>
</template>

<script>
import Wrap from "@/components/Wrap";
import Button from "@/components/Button";
export default {
  components: {
    Button,
    Wrap
  },
  data() {
    return {
      banner: false,
      title: this.$t("message.strid39"),
      text:
        "Application info submitted, please carry out the tournament accordingly"
    };
  },
  // created () {
  //   if (this.$route.query.t == 2) {
  //     this.title = 'Application submitted'
  //     this.text = 'Our staff will be in contact with you, please wait in patience'
  //   }
  // },
  methods: {
    back() {
      // window.sessionStorage.removeItem('form');
      this.$router.replace({ name: "law" });
    }
  }
};
</script>
>

<style lang="scss">
@media screen and (min-width: $mimViewWidth) {
  @import "@/assets/scss/views/success.scss";
}
@media screen and (max-width: $maxViewWidth) {
  @import "@/assets/scss/views/m/success.scss";
}
</style>
